<template>
  <div class="doc-menu">
    <button type="button" class="doc-menu-trigger" :aria-expanded="state.open" @click="toggleHelp">
      <i class="bi bi-question-circle"></i>
      <span class="doc-menu-label">{{ $t('help.title') }}</span>
    </button>
  </div>
</template>

<script>
/**
 * Bouton « Aide » du menu : ouvre le panneau d'aide contextuelle (HelpDrawer) — guides de la
 * page en cours, tous les guides, visite du menu.
 */
import { helpState, toggleHelp } from '@/help/helpState'

export default {
  name: 'DocumentationMenu',
  data() {
    return { state: helpState }
  },
  methods: {
    toggleHelp,
  },
}
</script>

<style scoped>
.doc-menu {
  position: relative;
  width: 100%;
}

.doc-menu-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: var(--kt-primary);
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: all 0.15s ease;
  font-size: 0.85rem;
  font-weight: 500;
}

.doc-menu-trigger:hover {
  filter: brightness(0.92);
}

.doc-menu-trigger i,
.doc-menu-trigger:hover i {
  color: #fff !important;
  font-size: 1.05rem;
}

.doc-menu-label,
.doc-menu-trigger:hover .doc-menu-label {
  color: #fff !important;
}
</style>

<style>
/* Menu réduit (et pas survolé) : seulement l'icône, centrée — comme les entrées du menu */
[data-kt-aside-minimize="on"] .aside:not(:hover) .doc-menu-trigger {
  justify-content: center;
  padding: 8px 0;
}
[data-kt-aside-minimize="on"] .aside:not(:hover) .doc-menu-label {
  display: none;
}
</style>
